class SecondaryNavigation {
  constructor() {
    this.secondaryNav = document.querySelector('.secondary-nav');
    this.form = this.secondaryNav?.querySelector('.secondary-nav__form');
    this.input = this.secondaryNav?.querySelector('.secondary-nav__input');
    this.button = this.secondaryNav?.querySelector('.secondary-nav__button');
    
    this.init();
  }

  init() {
    if (!this.secondaryNav) return;
    
    this.setupFormHandling();
    this.setupResponsiveBehavior();
    this.setupStickyBehavior();
    this.setupMegamenuBehavior();
  }

  setupFormHandling() {
    if (!this.form) return;

    // Handle form submission
    this.form.addEventListener('submit', (e) => {
      const query = this.input.value.trim();
      if (!query) {
        e.preventDefault();
        this.input.focus();
        return;
      }
    });

    // Handle search with Enter key
    this.input?.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        const query = this.input.value.trim();
        if (query) {
          this.form.submit();
        }
      }
    });

    // Auto-focus input when button is clicked
    this.button?.addEventListener('click', () => {
      if (!this.input.value.trim()) {
        this.input.focus();
      }
    });
  }

  setupResponsiveBehavior() {
    // Adjust behavior on mobile devices
    const mediaQuery = window.matchMedia('(max-width: 749px)');
    const mobileHideQuery = window.matchMedia('(max-width: 990px)');
    
    const handleResize = (e) => {
      // First check if we should hide on mobile
      if (mobileHideQuery.matches) {
        this.secondaryNav?.classList.add('secondary-nav--hidden');
        this.secondaryNav?.classList.remove('secondary-nav--mobile');
        return;
      }
      
      // Then handle mobile vs desktop behavior
      if (e.matches) {
        // Mobile behavior (only for tablets between 750px and 990px)
        this.secondaryNav?.classList.add('secondary-nav--mobile');
        this.secondaryNav?.classList.remove('secondary-nav--hidden');
      } else {
        // Desktop behavior
        this.secondaryNav?.classList.remove('secondary-nav--mobile', 'secondary-nav--hidden');
      }
    };

    const handleMobileHide = (e) => {
      if (e.matches) {
        // Hide on mobile
        this.secondaryNav?.classList.add('secondary-nav--hidden');
        this.secondaryNav?.classList.remove('secondary-nav--mobile');
      } else {
        // Show on larger screens
        this.secondaryNav?.classList.remove('secondary-nav--hidden');
        handleResize(mediaQuery);
      }
    };

    mediaQuery.addListener(handleResize);
    mobileHideQuery.addListener(handleMobileHide);
    
    // Initial setup
    handleMobileHide(mobileHideQuery);
    if (!mobileHideQuery.matches) {
      handleResize(mediaQuery);
    }
  }

  setupStickyBehavior() {
    // Sync with main header sticky behavior
    const stickyHeader = document.querySelector('sticky-header');
    
    if (stickyHeader) {
      // Observe changes in sticky header
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const isSticky = stickyHeader.classList.contains('shopify-section-header-sticky');
            this.secondaryNav?.classList.toggle('secondary-nav--sticky', isSticky);
          }
        });
      });

      observer.observe(stickyHeader, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  // Method to show/hide secondary navigation
  toggle(show = true) {
    if (!this.secondaryNav) return;
    
    if (show) {
      this.secondaryNav.style.display = 'block';
      this.secondaryNav.classList.add('secondary-nav--visible');
    } else {
      this.secondaryNav.classList.remove('secondary-nav--visible');
      setTimeout(() => {
        this.secondaryNav.style.display = 'none';
      }, 300);
    }
  }

  // Method to update input placeholder
  updatePlaceholder(placeholder) {
    if (this.input) {
      this.input.placeholder = placeholder;
    }
  }

  // Method to update button text
  updateButtonText(text) {
    if (this.button) {
      this.button.textContent = text;
    }
  }

  setupMegamenuBehavior() {
    // Close dropdowns when clicking outside
    document.addEventListener('click', (e) => {
      if (!this.secondaryNav?.contains(e.target)) {
        const openDropdowns = this.secondaryNav?.querySelectorAll('.secondary-nav__dropdown[open]');
        openDropdowns?.forEach(dropdown => dropdown.removeAttribute('open'));
      }
    });
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new SecondaryNavigation();
});

// Export for global use if needed
window.SecondaryNavigation = SecondaryNavigation; 